import React from "react";
import { PropTypes } from "prop-types";
// Limitless imports
import TextField from "@limitless/modern/inputs/text-field/TextField";
import { Grid } from "@mui/material";
const FeedbackByInput = ({
  onValueChange,
  action,
  value,
  isMandatory
}) => {
  const handleInputChange = value => {
    onValueChange({
      [action.payloadKey]: {
        value,
        isStepComplete: value === ""
      }
    });
  };
  return /*#__PURE__*/React.createElement(Grid, {
    sx: {
      mb: 2
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    value: value.value,
    name: "feedback",
    id: "feedbackInputField",
    label: action.title,
    onChange: event => {
      handleInputChange(event.target.value);
    },
    placeholder: "Type here",
    fullWidth: true,
    helperText: action.placeholder,
    required: isMandatory
  }));
};
export default FeedbackByInput;
FeedbackByInput.propTypes = {
  message: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired,
  value: PropTypes.object,
  isMandatory: PropTypes.bool.isRequired
};